import React, {useEffect, useState} from 'react';
import {Menu} from "grevlingui";
import {generateUuidv4} from "../../../utils/utils";
import moment from "moment";
import {Session} from "./Session/Session";
import {AddModal} from "./AddModal";
import {AddButton} from "../../General/AddButton";
import {Preset} from "./Preset";
import {MultiSortableContext} from "../../SortableList/SortableList";

const getThings = (key) => {
    const stored = localStorage.getItem(key)
    if (stored) return JSON.parse(stored);
    return [];
}

const getBool = (key) => {
    const stored = localStorage.getItem(key)
    if (stored) return JSON.parse(stored);
    return false;
}

export const Workout = () => {
    const [addingPreset, setAddingPreset] = useState(false);
    const [types] = useState(getThings('telleting-workout-types'));
    const [transitioned, setTransitioned] = useState(getBool('transitioned-to-multi-presets'));
    const [presets, setPresets] = useState(getThings('telleting-presets'));
    const [sessions, setSessions] = useState(getThings('telleting-sessions'));


    useEffect(() => {
        if (types && !transitioned) {
            setPresets([{
                name: 'Blodslit',
                id: generateUuidv4(),
                types
            }]);
            setTransitioned(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const deleteSession = si => () => {
        setSessions(oldSessions => [
            ...oldSessions
        ].filter((_, i) => i !== si))
    }

    const getSetSessionDate = si => date => {
        setSessions(oldSessions => {
            const newSessions = [...oldSessions];
            newSessions[si] = {
                ...newSessions[si],
                date
            }
            return newSessions;
        });
    }

    const getSetExercises = si => exercises => {
        setSessions(oldSessions => {
            const newSessions = [...oldSessions];
            newSessions[si] = {
                ...newSessions[si],
                exercises
            }
            return newSessions;
        });
    }

    const getUpdateExercise = si => (e, ei) => {
        setSessions(oldSessions => {
            const newSessions = [...oldSessions];
            const exercises = [...newSessions[si].exercises];
            exercises[ei] = e;
            newSessions[si] = {
                ...newSessions[si],
                exercises
            }
            return newSessions;
        });
    }

    const getAddExercise = si => (name, onSuccess) => {
        if (!name || name.length === 0) return;
        setSessions(oldSessions => {
            const newSessions = [...oldSessions];
            const exercises = [...newSessions[si].exercises, {name}];
            console.log('exercises: ', exercises);
            newSessions[si] = {
                ...newSessions[si],
                exercises
            }
            return newSessions;
        });
        onSuccess();
    }

    const addSession = (preset) => {

        const exercises = preset.types.map(name => ({name}));
        const newWorkout = {
            label: preset.name,
            id: generateUuidv4(),
            date: moment().startOf('day'),
            new: true,
            exercises
        };

        setSessions(oldWorkouts => [
            newWorkout,
            ...oldWorkouts
        ])
    }

    useEffect(() => {types && localStorage.setItem('telleting-workout-types', JSON.stringify(types));}, [types]);
    useEffect(() => {sessions && localStorage.setItem('telleting-sessions', JSON.stringify(sessions));}, [sessions]);
    useEffect(() => {presets && localStorage.setItem('telleting-presets', JSON.stringify(presets));}, [presets]);
    useEffect(() => {localStorage.setItem('transitioned-to-multi-presets', JSON.stringify(transitioned));}, [transitioned]);

    const addType = (newTypeName) => {
        if (newTypeName.length === 0)
            return;
        setAddingPreset(false);
        setPresets(pv => [
            ...pv,
            {
                name: newTypeName,
                id: generateUuidv4(),
                types: []
            }
        ]);
    }

    const modal = addingPreset ? (
        <AddModal
            heading="Ny type økt:"
            close={() => setAddingPreset(false)}
            confirm={addType}
        />
        ) : undefined;

    const sortSessions = (s1, s2) => {
        const m1 = moment(s1.date).valueOf();
        const m2 = moment(s2.date).valueOf();
        return m2 - m1;
    }

    const deletePreset = (i) => {
        setPresets(pv => {
            const boop = [...pv];
            boop.splice(i, 1);
            return boop;
        })
    }

    return (
        <div className="workout">
            <h1>Trening</h1>
            <div className="sessions">
                {/*<AddButton onClick={addSession}/>*/}
                <br/>
                {(sessions ?? [])
                    .sort(sortSessions)
                    .map((s, i) => (
                        <Session
                            key={s.id}
                            session={s}
                            setExercises={getSetExercises(i)}
                            updateExercise={getUpdateExercise(i)}
                            setSessionDate={getSetSessionDate(i)}
                            deleteSession={deleteSession(i)}
                            addExercise={getAddExercise(i)}
                            sessionIndex={i}
                            sessions={sessions}
                            old={() => {
                                setSessions(prev => {
                                    const newArray = [...prev];
                                    const newElement = {...newArray[i]};
                                    newArray[i] = newElement;
                                    delete newElement.new;
                                    return newArray;
                                })
                            }}
                        />
                    ))}
            </div>
            <Menu
                settings left
                color={'white'}
                bgColor={'var(--secondary)'}
                menuBgColor={'var(--secondary)'}
            >
                <p className="heading">Økter</p>
                <div className="presets">
                    <MultiSortableContext
                        setItems={setPresets}
                        items={presets}
                    >
                        {presets?.map((preset, i) => (
                            <Preset
                                key={preset.id}
                                preset={preset}
                                setPreset={newVal => {
                                    setPresets(old => old.with(i, newVal))
                                }}
                                doDelete={() => deletePreset(i)}
                                addSession={addSession}
                            />
                        ))}
                    </MultiSortableContext>
                    <br/>
                    <br/>
                    <div className="tricky thing">
                        <AddButton
                            onClick={() => setAddingPreset(true)}
                        />
                    </div>
                </div>
                {modal}
            </Menu>
        </div>
    );
}